import { CardHeader } from '@ps/isp-web-component-library';
import type { EventType } from '@ps/isp-web-services-types';
import React from 'react';

import PopularAccumulatorCount from '../PopularAccumulatorCount/PopularAccumulatorCount';

import styles from './PopularAccumulatorCardHeader.scss';
import bgImage from './header-bg.png';

interface Props {
  count: number;
  eventTypeId: EventType;
}

const PopularAccumulatorCardHeader: React.FC<Props> = ({ count, eventTypeId }) => (
  <CardHeader className={styles.cardHeader}>
    <div className={styles.background}>
      <div className={styles.container} style={{ backgroundImage: `url(${bgImage})` }}>
        <div className={styles.iconOuter}>
          <div className={styles.countInner}>
            <PopularAccumulatorCount count={count} eventTypeId={eventTypeId} />
          </div>
        </div>
      </div>
    </div>
  </CardHeader>
);

export default PopularAccumulatorCardHeader;
